import Partition from 'molecules/partition'
import bg from 'assets/cropAssure/management/bg.png';
import phoneIcon from 'assets/contact/phone.png'
import message from 'assets/contact/message.png'
import user from 'assets/contact/user-icon.png'
import location from 'assets/contact/location.png'
import { log } from 'console';

const contactList = [
	{
		heading : 'For Investor Queries and Grievances Redressal',
		title: 'Company Secretary & Compliance Officer',
		name : 'Aakansha Singh',
		email : 'investors@bharatrohan.in',
		phone : '+91-9266109913',
		address: '4th Floor B-117, DDA Sheds, Okhla Industrial Area Phase-I, New Delhi-110020'
	},
	{
		heading : 'Registrar and Transfer Agents (RTA)',
		name : 'Mr. M Murali Krishna',
		email : 'bharatrohan.ipo@kfintech.com',
		phone : '+91 40 6716 2222',
		company: 'KFin Technologies Limited',
		address: 'Selenium Tower B, Plot No. 31 & 32, Financial District, Nanakramguda, Hyderabad - 500032, Telangana, India',
		sebi: 'SEBI Registration No.: INR000000221'
	}
];

const GrievanceContent = () => {
  return (
	  <section className="bg-cream3 relative">
		<img
			src={bg}
			alt="plants"
			className="absolute bottom-3 right-0 hidden h-28 w-auto opacity-[15%] lg:h-32 2xl:h-40 md:block min-[1800px]:h-60"
		/>
      	<div className="py-16 px-4 w-container lg:w-container-lg">
	  		<Partition color="dark" text="Investor Grievances" />

			<div className="pt-16 grid grid-cols-1 md:grid-cols-1 gap-8 lg:pt-12">
				{
					contactList.map((contact, index) => {
						return (
							<GrievanceList
								key={index}
								heading={contact.heading}
								title={contact.title}
								name={contact.name}
								email={contact.email}
								phone={contact.phone}
								address={contact?.address}
								company={contact?.company}
								sebi={contact?.sebi}
							/>
						)
					})
				}
			</div>
		</div>
	  </section>
  )
}

export default GrievanceContent;


function GrievanceList({
  heading,
  title,
  name,
  address,
  email,
  phone,
  company,
  sebi
}: {
  heading: string
  title?: string
  name: string
  address?: string
  email: string
  phone: string
  company?: string
  sebi?: string
}) {
  return (
    <article className="group border-2 w-full h-full py-6 px-6 border-green rounded-2xl transition-colors duration-300 flex flex-col justify-between">
		<h6 className="font-bold text-[1.25rem] xl:text-[1.5rem] pb-3">
			{heading} 
		</h6>
		<div className="space-y-1">
			<div className="text-sm lg:text-base xl:text-lg mt-4">
				<div className="flex items-center gap-6 md:gap-6  lg:gap-9">
					<div className="grid place-content-center bg-yellow shadow-contact-points rounded-full h-10 w-10  lg:h-12 lg:w-12">
						<img
						className="h-6"
						src={user}
						alt="User"
						/>
					</div>
					<div className="flex flex-col items-center justify-center ">
					
						<h5 className="md:block hidden font-medium text-black hover:text-green focus-visible:text-green outline-none underline-offset-4 decoration-from-font">
						{name}
						</h5>
						<h6 className=" md:hidden block font-medium text-black hover:text-green focus-visible:text-green outline-none underline-offset-4 decoration-from-font">
						{name}
						</h6>
					
					</div>
				</div>
			</div>
			<div className="text-sm lg:text-base xl:text-lg">
				<div className="flex items-center gap-6 md:gap-6  lg:gap-9 my-5">
					{/* <div className="grid place-content-center bg-yellow shadow-contact-points rounded-full h-10 w-10  lg:h-12 lg:w-12">
						<img
						className="h-6"
						src={message}
						alt="Email"
						/>
					</div> */}
					<div className="flex flex-col items-center justify-center ">
						<div aria-label="Telephone">
							<h5 className=" md:block hidden font-medium font-bold text-black hover:text-green focus-visible:text-green outline-none decoration-from-font">
							{title}
							</h5>
							<h6 className=" md:hidden block font-medium font-bold text-black hover:text-green focus-visible:text-green outline-none decoration-from-font">
							{title}
							</h6>
						</div>
					</div>
				</div>
			</div>
			{ company && <div className="text-sm lg:text-base xl:text-lg">
				<div className="flex items-center gap-6 md:gap-6  lg:gap-9 my-5">
					{/* <div className="grid place-content-center bg-yellow shadow-contact-points rounded-full h-10 w-10  lg:h-12 lg:w-12">
						<img
						className="h-6"
						src={message}
						alt="Email"
						/>
					</div> */}
					<div className="flex flex-col items-center justify-center ">
						<div aria-label="Telephone">
							<h5 className=" md:block hidden font-medium font-bold text-black hover:text-green focus-visible:text-green outline-none decoration-from-font">
							{company}
							</h5>
							<h6 className=" md:hidden block font-medium font-bold text-black hover:text-green focus-visible:text-green outline-none decoration-from-font">
							{company}
							</h6>
						</div>
					</div>
				</div>
			</div>}
			{ address && <div className="text-sm lg:text-base xl:text-lg">
				<div className="flex items-center gap-6 md:gap-6  lg:gap-9 my-5">
					<div className="shrink-0 grid place-content-center bg-yellow shadow-contact-points rounded-full h-10 w-10 lg:h-12 lg:w-12">
						<img
						className="h-6"
						src={location}
						alt="Location"
						/>
					</div>
					<div className="flex flex-col items-center justify-center ">
					
						<h5 className="md:block hidden font-medium text-black hover:text-green focus-visible:text-green outline-none underline-offset-4 decoration-from-font">
						{address}
						</h5>
						<h6 className=" md:hidden block font-medium text-black hover:text-green focus-visible:text-green outline-none underline-offset-4 decoration-from-font">
						{address}
						</h6>
					
					</div>
				</div>
			</div>}
			<div className="text-sm lg:text-base xl:text-lg mt-4">
				<div className="flex items-center gap-6 md:gap-6  lg:gap-9">
					<div className="grid place-content-center bg-yellow shadow-contact-points rounded-full h-10 w-10  lg:h-12 lg:w-12">
						<img
						className="h-6"
						src={phoneIcon}
						alt="Mobile"
						/>
					</div>
					<div className="flex flex-col items-center justify-center ">
					
						<h5 className="md:block hidden font-medium text-black hover:text-green focus-visible:text-green outline-none underline-offset-4 decoration-from-font">
						{phone}
						</h5>
						<h6 className=" md:hidden block font-medium text-black hover:text-green focus-visible:text-green outline-none underline-offset-4 decoration-from-font">
						{phone}
						</h6>
					
					</div>
				</div>
			</div>
			<div className="text-sm lg:text-base xl:text-lg">
				<div className="flex items-center gap-6 md:gap-6  lg:gap-9 my-5">
					<div className="grid place-content-center bg-yellow shadow-contact-points rounded-full h-10 w-10  lg:h-12 lg:w-12">
						<img
						className="h-6"
						src={message}
						alt="Email"
						/>
					</div>
					<div className="flex flex-col items-center justify-center ">
					
						<h5 className="md:block hidden font-medium text-black hover:text-green focus-visible:text-green outline-none underline-offset-4 decoration-from-font">
						{email}
						</h5>
						<h6 className=" md:hidden block font-medium text-black hover:text-green focus-visible:text-green outline-none underline-offset-4 decoration-from-font">
						{email}
						</h6>
					
					</div>
				</div>
			</div>
			{ sebi && <div className="text-sm lg:text-base xl:text-lg">
				<div className="flex items-center gap-6 md:gap-6  lg:gap-9 my-5">
					{/* <div className="grid place-content-center bg-yellow shadow-contact-points rounded-full h-10 w-10  lg:h-12 lg:w-12">
						<img
						className="h-6"
						src={message}
						alt="Email"
						/>
					</div> */}
					<div className="flex flex-col items-center justify-center ">
						<div aria-label="Telephone">
							<h5 className=" md:block hidden font-medium font-bold text-black hover:text-green focus-visible:text-green outline-none decoration-from-font">
							{sebi}
							</h5>
							<h6 className=" md:hidden block font-medium font-bold text-black hover:text-green focus-visible:text-green outline-none decoration-from-font">
							{sebi}
							</h6>
						</div>
					</div>
				</div>
			</div>}
		</div>
	</article>

  )
}
